import React, { useEffect, useState } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { InputTextarea } from "primereact/inputtextarea";
import SuccessModal from "../../SuccessModal";
import {
  addStoreIncomeExpense,
  getBrandIncomeExpense,
  getBrandIncomeExpenseCategory,
  updateStoreIncomeExpense,
  updateStoreIncomeExpenseByAdmin,
} from "../../../services/IncomeExpense/IncomeExpense";
import { FloatLabel } from "primereact/floatlabel";
import { Calendar } from "primereact/calendar";
import { getStoreLocalData } from "../../../utils/localStorage";

const StoreIncomeExpenseCreateModalAdmin = ({
  storeIncomeExpenseCreateModalVisible,
  setStoreIncomeExpenseCreateModalVisible,
  sendDataToUserList,
  brandId,
  storeId,
  storeUserId,
  selectedUserItemValue,
  cashbookBalance,
  brandCreatedDate,
  enabledAmountRoundOffAdmin
}) => {

  const isRoundOffMode = enabledAmountRoundOffAdmin === 0;

  const inputRegex = isRoundOffMode
    ? /^\d*$/
    : new RegExp(`^\\d*\\.?\\d{0,${enabledAmountRoundOffAdmin}}$`);

  const [amountValue, setAmountValue] = useState("");
  const [remarkValue, setRemarkValue] = useState("");
  const [categoryValue, setCategoryValue] = useState("");
  const [brandIncomeValue, setBrandIncomeValue] = useState("");
  const [brandExpenseValue, setBrandExpenseValue] = useState("");

  const { storeLocalData } = getStoreLocalData();

  const [amountError, setAmountError] = useState("");
  const [remarkError, setRemarkError] = useState("");
  const [categoryError, setCategoryError] = useState("");
  const [brandIncomeError, setBrandIncomeError] = useState("");
  const [brandExpenseError, setBrandExpenseError] = useState("");
  const [dateValueError, setDateValueError] = useState("");

  const [modalVisible, setModalVisible] = useState(false);
  const [modalStatus, setModalStatus] = useState(false);
  const [modalText, setModalText] = useState("");

  const [isSubmitButtonPressed, setIsSubmitButtonPressed] = useState(false);
  const [categoryItems, setCategoryItems] = useState([]);
  const [brandIncomeExpenseData, setBrandIncomeExpenseData] = useState([]);
  const [brandIncomeData, setBrandIncomeData] = useState([]);
  const [brandExpenseData, setBrandExpenseData] = useState([]);

  const [dateValue, setDateValue] = useState(new Date());

  const minimumDate =  new Date(brandCreatedDate);
  // minimumDate.setMonth(minimumDate.getMonth() - 1000);

  const fetchStoreIncomeExpenseCategory = () => {
    getBrandIncomeExpenseCategory()
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data.map((item, index) => ({
            name: item.name.replace(/_/g, " "),
            value: item.id,
          }));

          setCategoryItems(Res);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  useEffect(() => {
    fetchStoreIncomeExpenseCategory();
  }, []);

  const fetchBrandIncomeExpense = () => {
    getBrandIncomeExpense(brandId)
      .then((response) => {
        if (!response.data.error) {
          const ResOne = response.data.filter(
            (item) =>
              item.status === true &&
              item.incomeExpenseCategory.name === "Income"
          );
          const ResTwo = response.data.filter(
            (item) =>
              item.status === true &&
              item.incomeExpenseCategory.name === "Expense"
          );
          const ResIncome = ResOne.map((item, index) => ({
            name: item.name.replace(/_/g, " "),
            value: item.id,
          }));
          setBrandIncomeData(ResIncome);
          const ResExpense = ResTwo.map((item, index) => ({
            name: item.name.replace(/_/g, " "),
            value: item.id,
          }));
          setBrandExpenseData(ResExpense);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  const handleDateChange = (selectedDate) => {
    if (selectedDate) {
      let selectedDateOnly = selectedDate.toISOString().split("T")[0];

      const currentTime = new Date();
      selectedDate.setHours(
        currentTime.getHours(),
        currentTime.getMinutes(),
        currentTime.getSeconds(),
        currentTime.getMilliseconds()
      );

      if (selectedDateOnly === "") {
        setDateValueError("Please select correct date");
      } else {
        setDateValueError("");
        setDateValue(selectedDate);
      }
    }
  };

  const handleCategoryChange = (item) => {
    setCategoryValue(item);
    fetchBrandIncomeExpense();
    setCategoryError("");
  };

  const selectedTemplate = (option, props) => {
    if (option) {
      return (
        <div className="flex align-items-center">
          <div>{option.name}</div>
        </div>
      );
    }

    return <span>{props.placeholder}</span>;
  };

  const optionTemplate = (option) => {
    return (
      <div className="flex align-items-center">
        <div>{option.name}</div>
      </div>
    );
  };

  useEffect(() => {
    if (selectedUserItemValue !== null) {
      setAmountValue(selectedUserItemValue?.amount || "");
      setRemarkValue(selectedUserItemValue?.remark.toString() || "");
      setCategoryValue(
        selectedUserItemValue?.brandIncomeExpense?.incomeExpenseCategory?.id ||
          ""
      );
      fetchBrandIncomeExpense();
      if (
        selectedUserItemValue?.brandIncomeExpense?.incomeExpenseCategory?.id ===
        1
      ) {
        setBrandIncomeValue(selectedUserItemValue?.brandIncomeExpense?.id);
      } else {
        setBrandExpenseValue(selectedUserItemValue?.brandIncomeExpense?.id);
      }
      setDateValue(new Date(selectedUserItemValue?.createdDate));
    }
  }, [selectedUserItemValue]);

  const handleConfirmPickup = () => {
    // Reset all previous errors

    setCategoryError("");
    setBrandIncomeError("");
    setBrandExpenseError("");
    setAmountError("");
    setRemarkError("");
    setDateValueError("");

    let isValid = true;

    if (selectedUserItemValue === null && categoryValue === "") {
      setCategoryError("Category is required");
      isValid = false;
    }

    if (categoryValue === 1 && brandIncomeValue === "") {
      setBrandIncomeError("Income is required");
      isValid = false;
    }

    if (categoryValue === 2 && brandExpenseValue === "") {
      setBrandExpenseError("Expense is required");
      isValid = false;
    }

    if (!amountValue) {
      setAmountError("Amount is required");
      isValid = false;
    }
    if (!remarkValue) {
      setRemarkError("Remark is required");
      isValid = false;
    }

    if (Number(amountValue) > cashbookBalance) {
      if (categoryValue === 2) {
        setAmountError(
          "Amount cannot be greater than the balance amount " + storeLocalData?.currencySymbol + " " +
            cashbookBalance
        );
        isValid = false;
      } else {
        setAmountError("");
        isValid = true;
      }
    }

    // const convertToUTC = (date) => {
    //   if (!date || !(date instanceof Date)) {
    //     console.error("Invalid date:", date);
    //     return null;
    //   }
    //   const offset = date.getTimezoneOffset(); // Offset in minutes
    //   return new Date(date.getTime() - offset * 60 * 1000 + 1000).toISOString();
    // };

    // // Convert dates
    //  const newDate = new Date(dateValue);
    //       newDate.setSeconds(newDate.getSeconds() + 1);
    const currentDateTimeDate = dateValue.toISOString();

    if (isValid) {
      if (!isSubmitButtonPressed) {
        // Set the state to indicate that the button has been pressed
        setIsSubmitButtonPressed(true);

        if (selectedUserItemValue === null) {
          // Logic for creating a new pickup request
          const data = {
            storeId: storeId,
            storeUserId: storeUserId,
            brandIncomeExpense: {
              id: categoryValue === 1 ? brandIncomeValue : brandExpenseValue,
            },
            amount: Number(amountValue),
            remark: remarkValue,
            createdDate: currentDateTimeDate,
          };
          // Call the service function for creating pickup request

          addStoreIncomeExpense(storeId, data)
            .then((response) => {
              if (!response.data.error) {
                const Res = response.data;
                if (Res) {
                  const message = Res.message;
                  const status = Res.status;
                  if (status === true) {
                    setModalVisible(true);
                    setModalStatus("success");
                    setModalText(message);
                  } else {
                    setModalVisible(true);
                    setModalStatus("not Success");
                    setModalText(message);
                  }

                  setAmountValue("");
                  setRemarkValue("");
                  setCategoryValue("");
                  setDateValue(new Date());
                  setBrandExpenseValue("");
                  setBrandIncomeValue("");

                  setAmountError("");
                  setRemarkError("");
                  setCategoryError("");

                  setIsSubmitButtonPressed(false);
                  sendDataToUserList({
                    success: true,
                  });
                  setStoreIncomeExpenseCreateModalVisible(false);
                }
              }
            })
            .catch((err) => {
              console.error("Error:", err);
            });
        } else {
          const data = {
            ...selectedUserItemValue,
            storeId: storeId,
            storeUserId: storeUserId,
            brandIncomeExpense: {
              id: categoryValue === 1 ? brandIncomeValue : brandExpenseValue,
            },
            amount: Number(amountValue),
            remark: remarkValue,
            createdDate: currentDateTimeDate,
          };
          // Call the service function for creating pickup request

          updateStoreIncomeExpenseByAdmin(storeId, data)
            .then((response) => {
              if (!response.data.error) {
                const Res = response.data;
                if (Res) {
                  const message = Res.message;
                  const status = Res.status;
                  if (status === true) {
                    setModalVisible(true);
                    setModalStatus("success");
                    setModalText(message);
                  } else {
                    setModalVisible(true);
                    setModalStatus("not Success");
                    setModalText(message);
                  }

                  setAmountValue("");
                  setRemarkValue("");
                  setCategoryValue("");
                  setDateValue(new Date());

                  setAmountError("");
                  setRemarkError("");
                  setCategoryError("");
                  setIsSubmitButtonPressed(false);
                  sendDataToUserList({
                    success: true,
                  });
                  setStoreIncomeExpenseCreateModalVisible(false);
                }
              }
            })
            .catch((err) => {
              console.error("Error:", err);
            });
        }
      }
    } else {
      setIsSubmitButtonPressed(false);
    }
  };

  const handleModalClose = () => {
    setAmountValue("");
    setRemarkValue("");
    setCategoryValue("");
    setDateValue(new Date());
    setBrandExpenseValue("");
    setBrandIncomeValue("");

    setAmountError("");
    setRemarkError("");
    setCategoryError("");
    setIsSubmitButtonPressed(false);
    sendDataToUserList({
      success: true,
    });
    setStoreIncomeExpenseCreateModalVisible(false);
  };

  return (
    <div className="flex justify-content-center">
      <Dialog
        visible={storeIncomeExpenseCreateModalVisible}
        style={{ width: "50vw" }}
        onHide={() => {
          if (!storeIncomeExpenseCreateModalVisible) return;
          handleModalClose();
        }}
        content={({ hide }) => (
          <div
            className="flex flex-column gap-2 "
            style={{
              borderRadius: "12px",
              backgroundColor: "#fff",
            }}
          >
            <div
              className="flex border-round-xl  justify-content-between align-items-center gap-2 px-4"
              style={{
                backgroundImage:
                  "radial-gradient(circle at left top, #2B70D7, #1752AA)",
              }}
            >
              <div>
                {selectedUserItemValue ? (
                  <i
                    className="pi pi-pencil"
                    style={{
                      fontSize: "20px",
                      cursor: "pointer",
                      color: "#fff",
                    }}
                  ></i>
                ) : (
                  <img src={"images/plus.png"} style={{ width: 30 }} />
                )}
              </div>
              <p className=" text-4xl text-primary-50 font-semibold uppercase">
                {selectedUserItemValue ? "Edit" : "ADD"} INCOME/ EXPENSE
              </p>
              <Button
                label="x"
                onClick={(e) => hide(e)}
                text
                className=" text-2xl text-primary-50 border-1 "
              ></Button>
            </div>

            <div
              className="mx-4 mt-4"
              style={{ pointerEvents: selectedUserItemValue ? "none" : "auto" }}
            >
              <FloatLabel>
                <Dropdown
                  id="categoryValue"
                  value={categoryValue}
                  onChange={(e) => handleCategoryChange(e.value)}
                  options={categoryItems}
                  optionLabel="name"
                  placeholder="Head"
                  className="w-full border-round-xl  text-2xl text-xl shadow-2"
                />
                <label
                  htmlFor="categoryValue"
                  className="text-md"
                  style={{ color: "blue" }}
                >
                  Head
                  <span style={{ color: "red" }}>*</span>
                </label>
              </FloatLabel>

              {categoryError && (
                <p className="text-lg font-normal" style={{ color: "red" }}>
                  {categoryError}
                </p>
              )}
            </div>

            {categoryValue === 1 && (
              <div className="mx-4 mt-4">
                <FloatLabel>
                  <Dropdown
                    id="brandIncomeValue"
                    value={brandIncomeValue}
                    onChange={(e) => {
                      setBrandIncomeValue(e.value);
                      setBrandIncomeError("");
                    }}
                    options={brandIncomeData}
                    optionLabel="name"
                    placeholder="Select Ledger"
                    className="w-full border-round-xl  text-2xl text-xl shadow-2"
                    filter
                    valueTemplate={selectedTemplate}
                    itemTemplate={optionTemplate}
                  />
                  <label
                    htmlFor="brandIncomeValue"
                    className="text-md"
                    style={{ color: "blue" }}
                  >
                    Select Ledger
                    <span style={{ color: "red" }}>*</span>
                  </label>
                </FloatLabel>

                {brandIncomeError && (
                  <p className="text-lg font-normal" style={{ color: "red" }}>
                    {brandIncomeError}
                  </p>
                )}
              </div>
            )}

            {/* {categoryValue === 1 && (
              <div className="mx-4 mt-4">
                <FloatLabel>
                  <Dropdown
                    id="brandIncomeValue"
                    value={brandIncomeValue}
                    onChange={(e) => {
                      setBrandIncomeValue(e.value);
                      setBrandIncomeError("");
                    }}
                    options={brandIncomeData}
                    optionLabel="name"
                    placeholder="Select Ledger"
                    className="w-full border-round-xl  text-2xl text-xl shadow-2"
                  />
                  <label
                    htmlFor="brandIncomeValue"
                    className="text-md"
                    style={{ color: "blue" }}
                  >
                    Select Ledger
                    <span style={{ color: "red" }}>*</span>
                  </label>
                </FloatLabel>

                {brandIncomeError && (
                  <p className="text-lg font-normal" style={{ color: "red" }}>
                    {brandIncomeError}
                  </p>
                )}
              </div>
            )} */}

            {categoryValue === 2 && (
              <div className="mx-4 mt-4">
                <FloatLabel>
                  <Dropdown
                    id="brandExpenseValue"
                    value={brandExpenseValue}
                    onChange={(e) => {
                      setBrandExpenseValue(e.value);
                      setBrandExpenseError("");
                    }}
                    options={brandExpenseData}
                    optionLabel="name"
                    placeholder="Select Ledger"
                    className="w-full border-round-xl  text-2xl text-xl shadow-2"
                    filter
                    valueTemplate={selectedTemplate}
                    itemTemplate={optionTemplate}
                  />
                  <label
                    htmlFor="brandExpenseValue"
                    className="text-md"
                    style={{ color: "blue" }}
                  >
                    Select Ledger
                    <span style={{ color: "red" }}>*</span>
                  </label>
                </FloatLabel>

                {brandExpenseError && (
                  <p className="text-lg font-normal" style={{ color: "red" }}>
                    {brandExpenseError}
                  </p>
                )}
              </div>
            )}
            {/* {categoryValue === 2 && (
              <div className="mx-4 mt-4">
                <FloatLabel>
                  <Dropdown
                    id="brandExpenseValue"
                    value={brandExpenseValue}
                    onChange={(e) => {
                      setBrandExpenseValue(e.value);
                      setBrandExpenseError("");
                    }}
                    options={brandExpenseData}
                    optionLabel="name"
                    placeholder="Select Ledger"
                    className="w-full border-round-xl  text-2xl text-xl shadow-2"
                  />
                  <label
                    htmlFor="brandExpenseValue"
                    className="text-md"
                    style={{ color: "blue" }}
                  >
                    Select Ledger
                    <span style={{ color: "red" }}>*</span>
                  </label>
                </FloatLabel>

                {brandExpenseError && (
                  <p className="text-lg font-normal" style={{ color: "red" }}>
                    {brandExpenseError}
                  </p>
                )}
              </div>
            )} */}
            <div className="flex justify-content-between align-items-center mx-4 mt-4">
              <Calendar
                id="buttondisplay"
                value={dateValue}
                onChange={(e) => handleDateChange(e.value)}
                showIcon
                minDate={minimumDate}
                maxDate={new Date()}
                className="w-full p-0"
                dateFormat="dd/mm/yy"
              />
            </div>
            <div className="mx-4 mt-4">
              <FloatLabel>
                <InputText
                  id="amountValue"
                  value={amountValue}
                  disabled={categoryValue === "" ? true : false}
                  onChange={(e) => {
                    const value = e.target.value;

                    if (inputRegex.test(value)) {
                    // if (/^\d*$/.test(value)) {
                      setAmountValue(value);

                      if (Number(value) > cashbookBalance) {
                        if (categoryValue === 2) {
                          setAmountError(
                            "Amount cannot be greater than the balance amount " + storeLocalData?.currencySymbol + " " +
                              cashbookBalance
                          );
                          setIsSubmitButtonPressed(true);
                        } else {
                          setAmountError("");
                          setIsSubmitButtonPressed(false);
                        }
                      } else {
                        setAmountError("");
                        setIsSubmitButtonPressed(false);
                      }
                    }
                  }}
                  className="w-full text-xl p-2 border-round-xl shadow-2"
                  style={{
                    backgroundColor: "#fff",
                  }}
                  placeholder="Amount"
                />
                <label
                  htmlFor="amountValue"
                  className="text-md"
                  style={{ color: "blue" }}
                >
                  Amount
                  <span style={{ color: "red" }}>*</span>
                </label>
              </FloatLabel>
              {amountError && (
                <p className="text-lg font-normal" style={{ color: "red" }}>
                  {amountError}
                </p>
              )}
            </div>

            <div className="mx-4">
              <InputTextarea
                id="remark"
                value={remarkValue}
                onChange={(e) => {
                  setRemarkValue(e.target.value);
                  setRemarkError("");
                }}
                className="w-full text-xl p-2 border-round-xl shadow-2"
                style={{
                  backgroundColor: "#fff",
                }}
                placeholder="Remark"
                maxLength={100}
              />
              {remarkError && (
                <p className="text-lg font-normal" style={{ color: "red" }}>
                  {remarkError}
                </p>
              )}
              <small style={{ display: 'block', marginBottom: '0.5rem' }}>
                Characters: {remarkValue.length} / 100
              </small>
            </div>

            <Button
              className="mt-1 mb-3 mx-4 border-round-xl "
              onClick={handleConfirmPickup}
              disabled={isSubmitButtonPressed}
            >
              <p className=" w-full text-2xl font-semibold flex justify-content-center">
                Submit
              </p>
            </Button>
          </div>
        )}
      ></Dialog>
      <SuccessModal
        setModalVisible={setModalVisible}
        modalVisible={modalVisible}
        status={modalStatus}
        text={modalText}
      />
    </div>
  );
};

export default StoreIncomeExpenseCreateModalAdmin;
